<template>
  <div class="info-wrap container trans">
    <sign-header :headerConfig="headerConfig" @handleClickIocn="handleClickIocn" />
    <div class="main">
      <div class="pay">
        <h2 class="tit">缴费状态</h2>
        <!-- 审核 -->
        <div
          class="wrap pay-content"
          v-if="currentSignup.id > 0 && currentSignup.status != '已完成'"
        >
          会议报名状态为:{{ currentSignup.status
          }}{{ currentSignup.status === "审核中" ? "，请完成转账后查询审核结果" : ""
          }}{{ currentSignup.status === "未通过" ? "，未通过报名申请，无法缴费" : "" }}
        </div>
        <!-- 审核通过 未缴费 且身份为需缴费的用户 -->
        <div
          class="wrap pay-btn"
          v-else-if="
            currentSignup.id > 0 &&
            currentSignup.status == '已完成' &&
            currentSignup.paid_status != '已缴费' &&
            currentSignup.paid_status != '申请退费' &&
            ['A1', 'A2', 'A3', 'A4', 'A5'].includes(currentSignup.attendid.code) > 0
          "
        >
          <p class="text">未缴费</p>
          <p class="money">原价 ¥{{ currentSignup.conference.price }}</p>
          <p class="money">缴费金额 ¥{{ payPrize }}</p>
          <el-button v-if="canpay" size="small" @click="handlePayment">立即缴费</el-button>
          <el-button v-else size="small">缴费已停止</el-button>
        </div>
        <!-- 审核通过 未缴费 且身份为不需缴费的用户(免费或者其他用户) -->
        <div
          class="wrap pay-btn"
          v-else-if="
            currentSignup.id > 0 &&
            currentSignup.status == '已完成' &&
            ['A7', 'A6'].includes(currentSignup.attendid.code)
          "
        >
          <p class="text">报名身份为{{ currentSignup.attendid.name }}，无需缴费</p>
          <p class="money">缴费金额 ¥0</p>
        </div>
        <!-- 审核通过 已缴费 paid_order为有订单的状态，在退费中就没有了-->
        <div
          class="wrap pay-success"
          v-else-if="
            currentSignup.id > 0 &&
            currentSignup.paid_order &&
            (currentSignup.paid_status == '已缴费' ||
              currentSignup.paid_status == '申请退费')
          "
        >
          <p class="text">缴费状态：{{ currentSignup.paid_status }}</p>
          <p class="money">缴费金额: ¥{{ payPrize }}</p>
          <p class="time">缴费时间: {{ payDate }}</p>
          <span
            class="refund"
            v-if="
              canrefund &&
              currentSignup.signinstatus !== '已签到' &&
              currentSignup.paid_status !== '退费中' &&
              currentSignup.paid_status !== '申请退费'
            "
            @click="handleRefund"
            >申请退费</span
          >
        </div>
      </div>
      <!--未缴费不显示开票状态-->
      <div
        class="invoice"
        v-if="
          currentSignup.id > 0 &&
          currentSignup.paid_order &&
          currentSignup.paid_status == '已缴费'
        "
      >
        <h2 class="tit">开票状态</h2>
        <!-- 未开票 -->
        <div class="wrap no-invoice">
          <p v-if="!isInvoiced">未开票</p>
          <p v-else>已开票</p>
          <el-button
            v-if="caninvoice && !isInvoiced"
            size="small"
            @click="applyInvoice"
            :loading="loading"
            >申请发票</el-button
          >
          <!-- <el-button
            style="background-color: grey"
            disabled
            v-else-if="!isInvoiced && currentSignup.signinstatus == '未签到'"
            size="small"
            >尚未签到</el-button
          > -->
          <el-button v-if="isInvoiced" style="background-color:transparent;" size="small"></el-button>
          <el-button v-if="isInvoiced" style="background-color:transparent;" size="small"></el-button>
          <el-button v-if="isInvoiced" style="background-color:transparent;" size="small"></el-button>
          <el-button v-if="isInvoiced" :loading="viewload" size="small" @click="viewInvoice">预览</el-button>
          <el-button v-if="isInvoiced" :loading="redflushload" size="small" @click="redflushInvoice">退票</el-button>
          <p v-if="!caninvoice && !isInvoiced">&nbsp;线上开票功能已关闭,请联系财务部010-58934281&nbsp;</p>
        </div>
        <div v-if="isInvoiced" class="wrap no-invoice">
          <el-button v-if="isInvoiced" :loading="pdfdownloadload" size="small" @click="downLoadInvoicePdf">下载发票PDF</el-button>
          <el-button v-if="isInvoiced" :loading="ofddownloadload" size="small" @click="downLoadInvoiceOfd">下载发票OFD</el-button>
          <el-button v-if="isInvoiced" :loading="xmldownloadload" size="small" @click="downLoadInvoiceXml">下载发票XML</el-button>

        </div>
      </div>
    </div>

    <sign-dialog
      v-model="dialogShow"
      :dialogConfig="dialogConfig"
      @closeDialog="closeDialog"
    >
      <component
        :is="currentView"
        :dialogConfig="dialogConfig"
        @handleClickSure="handleClickSure"
        @handleClickPaid="handleFinishPay"
        @handleClickNewPay="goWechatPayment"
      />
    </sign-dialog>
    <vulueDialog :valueDialogShow="valueDialogShow" :valueShow="valueShow" @closeDialogs="closeDialogs" @closeDialog1="closeDialog1" />
    <vulueDialog :valueDialogShow="refundNoticeShow" :valueShow="refundNoticeInfo" @closeDialogs="refundNoticeShow = false"/>
  </div>
</template>

<script>
import dayjs from "dayjs"
import "dayjs/locale/zh-cn"
import signHeader from "@/components/header";
import signDialog from "@/components/dialog";
import { Invoice } from "@/store/entity/invoice";
import { Confsite } from "@/store/entity/confsite";
import { UserOrderRecord } from "@/store/entity/pay";
import CurrentUserMixin from "@/mixin/CurrentUser";
import vulueDialog from "../../components/dialog/valueData.vue";

export default {
  name: "informations",
  components: {
    signHeader,
    signDialog,
    vulueDialog,
    examineFail: () => import("../signUp/components/examineFail.vue"),
    existPay: () => import("./existPay.vue"),
    payFail: () => import("../signUp/components/payFail.vue"),
    paySuccess: () => import("../signUp/components/paySuccess.vue"),
    invoiceFail: () => import("../signUp/components/invoiceFail.vue"),
  },
  mixins: [CurrentUserMixin],
  data() {
    return {
      redflushload:false,
      pdfdownloadload:false,
      ofddownloadload:false,
      xmldownloadload:false,
      viewload:false,
      valueDialogShow: false,
      valueShow:"请您在会议现场完成签到后申请开票!",
      refundNoticeShow: false,
      isInvoiced: false,
      invoiceid: "",
      loading: false,
      currentCoference: {},
      headerConfig: {
        headerIcon: "city ct-xiangyou",
        headerTitle: "缴费管理",
      },
      currentView: null,
      dialogShow: false,
      dialogConfig: {
        title: "",
        width: "80%",
      },
      payPrize: 0.0, // 要支付的金额
      payDate: null, // 支付日期
      existPayRecords: [], // 支付过的
    };
  },

  computed: {
    beforeconfdate() {
      const confdate = this.currentSignup.conference.conferencedate
      return dayjs(confdate).subtract(1, "day").format("YYYY年MM月DD日")
    },
    confdate() {
      const confdate = this.currentSignup.conference.conferencedate
      return dayjs(confdate).format("YYYY年MM月DD日")
    },
    refundNoticeInfo(){
      return `报名后因特殊原因无法参会的，请于${this.beforeconfdate}24点会议开始前申请退款，${this.confdate}0点起将无法退款`
    },
    //是否显示【申请退费】
    canrefund(){
      let d1 =new Date().getTime()
      let d2 = new Date(this.currentSignup.conference.conferencedate).getTime()
      if(this.currentSignup.conference.conferencedate!=null && d1>=d2){
        return false;
      }else{
        return true;
      }
    },
    canpay(){
      let d1 =new Date().getTime()
      let d2 = new Date(this.currentSignup.conference.paydeadline).getTime()
      if(this.currentSignup.conference.paydeadline!=null && d1>=d2){
        return false;
      }else{
        return true;
      }
    },
    caninvoice(){
      let d1 =new Date().getTime()
      let d2 = new Date(this.currentSignup.conference.invoicedeadline).getTime()
      
      if(this.currentSignup.conference.invoicedeadline!=null && d1>=d2){
        return false;
      }else{
        return true;
      }
    }
  },

  created() {
    this.isInvoice(this.currentSignup.id);
    this.setStatusFromSignupInfo(this.currentSignup);
  },

  watch: {
    currentSignup: {
      handler(currentSignup) {
        this.isInvoice(currentSignup.id);
        this.setStatusFromSignupInfo(currentSignup);
      },
      deep: true,
    },
  },

  methods: {
    setStatusFromSignupInfo(currentSignup) {
      // 根据报名信息设置页面状态
      if (currentSignup.id == undefined || currentSignup.id == null) {
        // 如果没找到注册信息currentSignup是{}
        this.dialogShow = true;
        this.currentView = "examineFail";
        this.dialogConfig.title = "抱歉,未找到报名信息";
      } else if (currentSignup.id > 0) {
        if (
          currentSignup.status == "已完成" &&
          ["A6", "A7"].includes(currentSignup.attendid.code)
        ) {
          // 无需缴费的用户
          this.dialogShow = false;
          this.currentView = null;
        } else if (
          currentSignup.status == "已完成" &&
          ["A1", "A2", "A3", "A4", "A5"].includes(currentSignup.attendid.code) &&
          currentSignup.paid_order_id &&
          currentSignup.paid_status == "已缴费"
        ) {
          // 需缴费且缴费完成的用户
          this.getPaidInfo();
          this.dialogShow = false;
          this.dialogConfig.title = "";
          this.currentView = null;
        } else {
          this.getPayPrize();
          this.dialogShow = false;
          this.dialogConfig.title = "抱歉,未缴费";
          this.currentView = null;
        }
      } else {
        this.dialogShow = false;
        this.currentView = null;
      }
    },
    async redflushInvoice(){
      try{
        this.redflushload = true;
        let res = await Invoice.redflushInvoice(this.currentSignup.paid_order_id);
        this.dialogShow = true;
        if(res.code=="S0000"){
          this.currentView = "redflushSuccess";
          this.dialogConfig.title = "红冲成功";
          this.isInvoice(this.currentSignup.id)
        }else{
          this.currentView = "redflushFail";
          this.dialogConfig.title = "红冲失败！"+res.msg;
        }
        
      }catch(e){
        
      }finally{
        this.redflushload = false;

      }
    },
    async downLoadInvoicePdf() {
      this.pdfdownloadload = true;
      let data = await Invoice.queryPdf(this.invoiceid);
      this.pdfdownloadload = false;
      if(data.code==='S0000'){
          const link = document.createElement("a");
          link.href = data.msg.pdfUrl;
          link.click();
      }else{
        this.dialogShow = true;
        this.dialogConfig.title = data.msg;
      }
    },
    async downLoadInvoiceOfd() {
      this.ofddownloadload = true;
      let data = await Invoice.queryPdf(this.invoiceid);
      this.ofddownloadload = false;
      if(data.code==='S0000'){
          const link = document.createElement("a");
          link.href = data.msg.ofdUrl;
          link.click();
      }else{
        this.dialogShow = true;
        this.dialogConfig.title = data.msg;
      }
    },
    async downLoadInvoiceXml() {
      this.xmldownloadload = true;
      let data = await Invoice.queryPdf(this.invoiceid);
      this.xmldownloadload = false;
      if(data.code==='S0000'){
          const link = document.createElement("a");
          link.href = data.msg.xmlUrl;
          link.click();
      }else{
        this.dialogShow = true;
        this.dialogConfig.title = data.msg;
      }
    },
    async viewInvoice() {
      this.viewload = true;
      let data = await Invoice.queryPdf(this.invoiceid);
      this.viewload = false;
      if(data.code==='S0000'){
          const link = document.createElement("a");
          link.href = data.msg.h5Url;
          link.click();
      }else{
        this.dialogShow = true;
        this.dialogConfig.title = data.msg;
      }
    },
    async getPayPrize() {
      const prize = await UserOrderRecord.getPrizeBySignupId(this.currentSignup.id);
      this.payPrize = prize;
    },
    async getPaidInfo() {
      const res = await UserOrderRecord.fetch({
        uuid: this.currentSignup.paid_order_id,
        per_page: 1,
      });
      if (res.total > 0) {
        const paid_order = res.results[0];
        this.payPrize = paid_order.paid_prize;
        this.payDate = this.$moment(paid_order.finish_paid_time).format(
          "YYYY年MM月DD日 HH时mm分ss秒"
        );
      } else {
        this.payPrize = null;
        this.payDate = null;
      }
    },

    async isInvoice(signup_id) {
      if (signup_id == undefined || signup_id == null) {
        // 如果没找到注册信息currentSignup是{}
        this.dialogShow = true;
        this.currentView = "examineFail";
        this.dialogConfig.title = "抱歉,未找到报名信息";
      } else if (signup_id > 0) {
        let data = await Invoice.isInvoiced(signup_id);
        if (data.isinvoiced == true) {
          this.isInvoiced = true;
          this.invoiceid = data.invoice.id;
        } else {
          this.isInvoiced = false;
        }
      }
    },
    handleClickIocn() {
      history.go(-1);
    },

    editInfo() {
      this.$router.push("/editInfo");
    },

    /* 申请退费 */
    handleRefund() {
      this.$router.push("/refund");
    },

    /* 申请发票 */
    applyInvoice() {
      const UNSIGN_MAKEOUT_INVOICE_DEADLINE = 2
      let d1 =new Date().getTime()
      let d2 = new Date(this.currentSignup.conference.conferencedate).getTime()
      if(d1-d2<=(UNSIGN_MAKEOUT_INVOICE_DEADLINE)*24*3600*1000 && this.currentSignup.signinstatus=="未签到"){
        this.valueDialogShow = true;
      }else{
        this.$router.push("/invoice");
      }
    },

    closeDialogs(val){
      this.valueDialogShow = val
      // this.loading = val;
    },

    closeDialog1(done){
      this.valueDialogShow = false
    },

    /* 立即缴费 */
    async handlePayment() {
      //先校验报名时选的会场是否已满
      await Confsite.isfulled(this.currentSignup.id)
      // 先检测是不是已经支付过，只检查最近支付的一条
      const res = await UserOrderRecord.fetch({
        signup_id: this.currentSignup.id,
        per_page: 1,
        buyer_id: this.currentUser.id,
        order_by_desc: "create_time",
      });
      this.existPayRecords = res.results.filter((x) => x.refund_status != "已退费");
      if (this.existPayRecords.length == 0) {
        // 没有支付记录，直接去支付
        this.goWechatPayment();
      } else {
        this.dialogShow = true;
        this.dialogConfig.title = "提示：";
        this.currentView = "existPay";
      }
    },
    goWechatPayment() {
      const is_wechat = UserOrderRecord.checkIsWechat();
      // const is_wechat = true
      if (is_wechat) {
        // 支付的逻辑，跳转到wechatPay界面
        const appid = process.env.VUE_APP_WECHAT_APPID;
        const path = this.$router.resolve({
          name: "WechatPayView",
          query: { signupId: this.currentSignup.id },
        }).route.fullPath;
        // 可能部署在不是根目录，将当前的目录替换掉后拼出支付页面路径
        const base_url = window.location.href.replace(this.$route.fullPath, "");
        const redirecturi = encodeURIComponent(base_url + path);
        const finalurl = `https://open.weixin.qq.com/connect/oauth2/authorize?appid=${appid}&redirect_uri=${redirecturi}&response_type=code&scope=snsapi_base#wechat_redirect`;
        window.location.href = finalurl;
      } else {
        this.dialogShow = true;
        this.dialogConfig.title = "不在微信环境或者微信版本低于5.0，请在微信中完成缴费";
        this.currentView = "payFail";
      }
    },

    async handleFinishPay() {
      // 给后台发请求调查单接口是否已支付完成
      // 有可能用户支付完成了，但忘记点完成付款按钮
      const actions = async (orders) => {
        for (const order of orders) {
          await UserOrderRecord.finisheOrder({ trade_no: order.trade_no });
        }
      };
      await actions(this.existPayRecords);
    },

    closeDialog(done) {
      done();
    },

    handleClickSure() {
      this.dialogShow = false;
    },
  },
};
</script>

<style lang="scss" scoped>
.main {
  margin: 0 15px;

  .wrap {
    width: 100%;
    padding: 15px;
    margin-top: 15px;
    background: #fff;
    box-shadow: 0 0 5px 2px rgba(0, 0, 0, 0.1);
    border-radius: 5px;
    box-sizing: border-box;
  }

  .pay {
    margin-top: 30px;
    .tit {
      font-size: 16px;
      color: var(--main-color);
      padding-left: 8px;
      font-weight: bold;
      border-left: 4px solid var(--main-color);
    }

    .pay-content {
      line-height: 40px;
      font-size: 14px;
      color: #999;
    }

    .pay-btn {
      display: flex;
      flex-direction: row;
      justify-content: space-between;
      align-items: center;
      height: 50px;

      .el-button {
        border: none;
        background: var(--main-color);
        color: #fff;
      }
    }

    .pay-success {
      position: relative;
      p {
        line-height: 30px;
        color: #999;
      }

      .refund {
        position: absolute;
        top: 15px;
        right: 15px;
        border: none;
        font-size: 14px;
        color: var(--main-color);
      }
    }
  }

  .invoice {
    margin-top: 30px;
    padding-bottom: 30px;

    .tit {
      font-size: 16px;
      color: var(--main-color);
      padding-left: 8px;
      font-weight: bold;
      border-left: 4px solid var(--main-color);
    }

    .no-invoice {
      display: flex;
      flex-direction: row;
      justify-content: space-between;
      align-items: center;
      height: 60px;

      .el-button {
        border: none;
        background: var(--main-color);
        color: #fff;
      }
    }
  }
}
::v-deep .el-dialog {
  background: var(--main-color);
  border-radius: 5px;
  .el-dialog__title,
  .el-dialog__close {
    color: #fff;
  }
}
</style>
